import styled from '@emotion/styled'
import * as constants from 'view/styles/constants'

export const AxeBoardContentContainer = styled.div`
  flex: 1 1 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  max-width: 100%;
  background-color: ${constants.CORE_PRIMARY};
`
